/**
 * Component gets added to NonMountingRail entities if there are no adjustable
 * products sold the market. Used in AdjustableSectionValidation to prevent resizing
 * to adjustable sizes.
 */
class ProhibitAdjustableComponent {
    constructor() {
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.typeId = ProhibitAdjustableComponent.id;
    }
    eq(_other) {
        return true;
    }
}
ProhibitAdjustableComponent.id = 2102;
export default ProhibitAdjustableComponent;
//# sourceMappingURL=ProhibitAdjustableComponent.js.map